import React, { useState, useContext, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import Switch from "react-switch";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  customStyle
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";
import Select from "react-select";

//3rd party packages
import { Helmet } from "react-helmet";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";

const MealTimeAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();
  //getting context values here
  const { loading, setLoading } = useContext(SettingsContext);
  const { branchForSearch, branchForListSearch } = useContext(RestaurantContext)

  // States hook here
  //new meal
  let [newMeal, setNewMeal] = useState({
    id: null,
    name: "",
    code: "",
    branch: null,
    from_time: "",
    to_time: "",
    status: 1,
    edit: false,
  });

  //set edit true & values
  const handleSetEdit = async () => {
    try {
      const url = BASE_URL + "/settings/meal-times/" + id;
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (res.data) {
        const fromTime = moment(res.data.from_time, 'HH:mm:ss');;
        const toTime = moment(res.data.to_time, 'HH:mm:ss');
        const branch = branchForListSearch[res.data.branch_id];

        setNewMeal({
          ...newMeal,
          name: res.data.name,
          code: res.data.code,
          branch: branch,
          from_time: fromTime,
          to_time: toTime,
          status: res.data.status,
          edit: true,
        });
      }
    } catch (err) {
      if (err.response?.data?.status === 0) {
        toast.error(<span>{err.response.data.message}</span>, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return;
      }
      toast.error(`${_t(t("Can't get data try again"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  //useEffect == componentDidMount
  useEffect(() => {
    if (id && branchForListSearch) {
      handleSetEdit();
    }
  }, [branchForListSearch]);

  //set name hook
  const handleSetNewMeal = (e) => {
    setNewMeal({
      ...newMeal,
      [e.target.name]: e.target.value,
    });
  };

  const handleSetNewSelect = (key, value)=>{
    setNewMeal({
      ...newMeal,
      [key]: value,
    });
  }

  const handleTimeToChange = (key, value) => {
    setNewMeal({
      ...newMeal,
      [key]: value,
    });
  };

  //Save New variation
  const handleSaveNewMealTime = (e) => {
    e.preventDefault();
    if(!newMeal.from_time || !newMeal.to_time){
      toast.error(`${_t(t("Please select time"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      })
      return false;
    }
    setLoading(true);
    const endPoint = id ? `/settings/meal-times/${id}` : "/settings/meal-times";
    const url = BASE_URL + endPoint;
    const method = id ? "put" : "post";
    const fromTime = newMeal.from_time ? moment(newMeal.from_time).format("HH:mm") : "";
    const toTime = newMeal.to_time ? moment(newMeal.to_time).format("HH:mm") : "";

    const formData = {
      name: newMeal.name,
      code: newMeal.code,
      branch_id: newMeal.branch?.id,
      from_time: fromTime,
      to_time: toTime,
      status: newMeal.status
    }

    return axios[method](url, formData, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    })
      .then((res) => {
        setLoading(false);
        if(res.data){
          setNewMeal({
            name: "",
            code: "",
            from_time: "",
            to_time: "",
            status: 1,
            edit: false,
            uploading: false,
          });
          toast.success(`${_t(t("Meal Time has been added"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          history.push("/dashboard/manage/food/meal-times")
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.data?.status === 0) {
          toast.error(<span>{error.response.data.message}</span>, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          return;
        }

        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Meal Time"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="fk-scroll--pos-menu" data-simplebar>
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {loading === true ? (
                      tableLoading()
                    ) : (
                      <div key="fragment3">
                        {/* next page data spin loading */}
                        {/* spin loading ends */}

                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {!newMeal.edit
                                    ? _t(t("Add meal time"))
                                    : _t(t("Update meal time"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center"></div>
                          </div>
                        </div>

                        <div key="fragment-dept-tag-1">
                          <form
                            onSubmit={handleSaveNewMealTime}
                            autoComplete="off"
                            className="row card p-2 mx-3 mb-5 new-text-style"
                          >
                            <div className="row mt-2">
                              <div className="col-4">
                                <label htmlFor="name" className="form-label">
                                  {_t(t("Name"))}{" "}
                                  <small className="text-danger">*</small>
                                </label>
                                <input
                                  type="text"
                                  className="form-control "
                                  id="name"
                                  name="name"
                                  placeholder="e.g. Lunch"
                                  value={newMeal.name || ""}
                                  required
                                  onChange={handleSetNewMeal}
                                />
                              </div>
                              <div className="col-4">
                                <label htmlFor="code" className="form-label">
                                  {_t(t("Code"))}{" "}
                                  <small className="text-danger">*</small>
                                </label>
                                <input
                                  type="text"
                                  className="form-control "
                                  id="code"
                                  name="code"
                                  required
                                  placeholder="e.g B-02"
                                  value={newMeal.code || ""}
                                  onChange={handleSetNewMeal}
                                />
                              </div>

                              <div className="col-4">
                                <label htmlFor="code" className="form-label">
                                  {_t(t("Branch"))}{" "}
                                </label>
                                <Select
                                  options={branchForSearch ? branchForSearch : []}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  classNamePrefix="select"
                                  value={newMeal.branch}
                                  styles={customStyle}
                                  isClearable
                                  onChange={(branch)=>handleSetNewSelect("branch",branch)}
                                  maxMenuHeight="200px"
                                  placeholder={_t(t("select branch")) + ".."}
                                />
                              </div>
                            </div>

                            <div className="row mt-3">
                              <div className="col-3">
                                <label htmlFor="code" className="form-label">
                                  {_t(t("From Time"))}
                                </label>
                                <Datetime
                                  value={newMeal.from_time}
                                  onChange={(date) =>
                                    handleTimeToChange("from_time", date)
                                  }
                                  dateFormat={false} // Hide the date picker
                                  className="col "
                                  dropdownMode="select"
                                  timeConstraints={{
                                    minutes: { step: 5 }, // Customize time selection steps
                                  }}
                                />
                              </div>
                              <div className="col-3">
                                <label htmlFor="code" className="form-label">
                                  {_t(t("To Time"))}
                                </label>
                                <Datetime
                                  value={newMeal.to_time}
                                  onChange={(date) =>
                                    handleTimeToChange("to_time", date)
                                  }
                                  dateFormat={false} // Hide the date picker
                                  className="col "
                                  dropdownMode="select"
                                  timeConstraints={{
                                    minutes: { step: 5 }, // Customize time selection steps
                                  }}
                                />
                              </div>
                              <div className="col-6">
                                <label htmlFor="code" className="form-label d-block">
                                  {_t(t("Status"))}
                                </label>
                                <Switch
                                  checked={newMeal?.status}
                                  name="status"
                                  onChange={(status) =>
                                    handleTimeToChange("status", status ? 1 : 0)
                                  }
                                  height={20}
                                  width={42}
                                  offColor="#ee5253"
                                  className="mt-1"
                                />
                              </div>
                            </div>

                            <div className="row mt-4">
                              <div className="d-flex justify-content-end">
                                <div className="col-3 d-flex justify-content-end">
                                  <button
                                    type="button"
                                    className="btn rounded hov-btn mr-3"
                                    onClick={() =>
                                      history.push(
                                        "/dashboard/manage/food/meal-times"
                                      )
                                    }
                                  >
                                    <i className="fa fa-arrow-left" aria-hidden="true"></i>{" "}
                                    {_t(t("Back"))}
                                  </button>
                                  <button
                                    disabled={loading}
                                    type="submit"
                                    className="btn btn-primary rounded"
                                  >
                                    <i className="fa fa-floppy-o" aria-hidden="true"></i>{" "}
                                    {!newMeal.edit
                                      ? _t(t("Save"))
                                      : _t(t("Update"))}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default MealTimeAction;
